module.exports = __webpack_public_path__ + "media/images/helpbox_bottom-db9e0540acebd6ae99310587a39fab71.png";